module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_menu-473f264752727105e052bd7cbe5544b9.svg";